import { Link } from 'wouter';
import { AuthDialog } from '@/components/auth/auth-dialog';
import { AuthMenu } from './auth/auth-menu';
import { Drawer, DrawerTrigger, DrawerContent, DrawerTitle } from '@/components/ui/drawer';
import Menu from '@icons/menu.svg?react';
import { useState } from 'react';
import { Button } from './ui/button';
import Logo from '@/assets/svg/logos/logo.svg';
import { cn } from '@/lib/utils';

const links = [
  // { title: 'Расписание', href: 'https://quizplease.ru/schedule' },
  // { title: 'Рейтинг', href: 'https://quizplease.ru/rating' },
  // { title: 'Магазин', href: 'https://quizplease.ru/shop' },
  // { title: 'Франшиза', href: 'https://franch.quizplease.com/' },
  // { title: 'Игры Хоум', href: '/', isActive: true },
  {
    title: 'Корпоративы',
    href: 'https://quizplease.me/corp?utm_source=qphome&utm_medium=online&utm_campaign=homecorp',
  },
  {
    title: 'Игры в барах',
    href: 'https://quizplease.me/schedule?utm_source=qphome&utm_medium=online&utm_campaign=qphomeschedule',
  },
  {
    title: 'Стримы',
    href: 'https://quizplease.ru/stream-page?utm_source=qphome&utm_medium=online&utm_campaign=qphomestreamshapka',
  },
];

export function Header() {
  const [open, setOpen] = useState(false);

  const navLinks = links.map((link) => {
    const isExternal = link.href.startsWith('http');
    const className = cn(
      'text-white font-semibold cursor-pointer',
      link.isActive ? 'text-primary' : '',
    );

    return isExternal ? (
      <a
        key={link.href}
        href={link.href}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
      >
        {link.title}
      </a>
    ) : (
      <Link key={link.href} to={link.href} className={className}>
        {link.title}
      </Link>
    );
  });

  return (
    <header className="flex justify-between !bg-transparent relative z-20 main-container transition-all duration-300 h-[4rem] 2xl:h-[6rem]">
      <Link to={'/'}>
        <img src={Logo} alt="Квиз, плиз!" className="cursor-pointer h-full p-1 2xl:p-0.5" />
      </Link>
      <a href="https://quizplease.ru/"></a>
      <nav className="py-[12px] flex flex-row justify-end h-full w-full">
        <div className="flex gap-4 lg:gap-8 justify-end items-center flex-row lg:flex-row-reverse">
          <AuthMenu />
          <div className="w-full justify-end items-center gap-8 hidden lg:flex">{navLinks}</div>
          <div className="flex">
            <Drawer open={open} onOpenChange={setOpen}>
              <DrawerTrigger asChild className="lg:hidden">
                <Button size="icon" variant="ghost" className="rounded-full hover:bg-secondary">
                  <Menu className="fill-white" />
                </Button>
              </DrawerTrigger>
              <DrawerContent aria-describedby="" className="min-h-[50%] user-layout">
                <DrawerTitle>
                  <div className="text-3xl text-right mb-8">Меню</div>
                </DrawerTitle>
                <div className="flex text-right flex-col space-y-4">{navLinks}</div>
              </DrawerContent>
            </Drawer>
          </div>
        </div>
      </nav>
      <AuthDialog />
    </header>
  );
}
